<!-- 屏蔽助学单位设置开课结课时间权限，由学院管理人员设置，，任课教师重名导致分配错误问题 -->
<template>
  <div id="CourseOpeningList">
    <!-- <div class="control" v-if="roleType != 60"> -->
    <div class="control" v-if="userType === '1' || userType === '52'">
      <el-button type="primary" @click="setCourseLearningTime()">设置学习时间</el-button>
    </div>
    <el-table ref="table" :data="tableData" style="width: 100%" size="small"
      :header-cell-style="{ 'background-color': '#e8eff9' }" @selection-change="handleSelectionChange"
      @sort-change="sortChange">
      <el-table-column type="selection" width="50" align="center">
      </el-table-column>
      <el-table-column type="index" label="序号" width="55" align="center"></el-table-column>
      <el-table-column prop="videoTitle" label="课程名称" sortable="custom" align="center"></el-table-column>
      <el-table-column prop="courseCode" label="课程代码" align="center">
      </el-table-column>

      <el-table-column prop="courseAttribute" label="课程属性" align="center"></el-table-column>
      <el-table-column prop="typeName" label="考试方式" align="center"></el-table-column>
      <el-table-column label="课程编码" align="center">
        <template slot-scope="scope">
          <div>
            {{ scope.row.mhmName + '-' + scope.row.NAME + '-' + scope.row.videoTitle }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="NAME" label="任课讲师" align="center">
        <template slot-scope="scope">
          <div v-if="scope.row.teacherName">
            {{ scope.row.teacherName }}
          </div>
          <div v-else class="set_tips">--请设置讲师--</div>
        </template>
      </el-table-column>
      <el-table-column prop="openTime" label="开课时间" align="center">
        <template slot-scope="scope">
          <div v-if="scope.row.openTime">
            {{ scope.row.openTime }}
          </div>
          <div v-else class="set_tips">--请设置时间--</div>
        </template>
      </el-table-column>
      <el-table-column prop="endTime" label="结课时间" align="center">
        <template slot-scope="scope">
          <div v-if="scope.row.endTime">
            {{ scope.row.endTime }}
          </div>
          <div v-else class="set_tips">--请设置时间--</div>
        </template>
      </el-table-column>
      <el-table-column prop="courseEndDate" label="课程考核结束时间" align="center">
        <template slot-scope="scope">
          <div v-if="scope.row.checkTime">
            {{ scope.row.checkTime }}
          </div>
          <div v-else class="set_tips">--请设置时间--</div>
        </template>
      </el-table-column>
      <el-table-column prop="status" label="课程状态" align="center">
        <template slot-scope="scope">
          <div :class="scope.row.status === '开课中' ? '  ' : ''">
            {{ scope.row.status }}
          </div>
        </template>
      </el-table-column>
      <!-- <el-table-column prop="remark" label="学习结果" align="center">
        <template>
          <div style="cursor: pointer" @click="checkLearingOutcome">查看</div>
        </template>
      </el-table-column> -->
      <el-table-column width="250" label="操作" align="center">
        <template slot-scope="scope">
          <div style="display: flex">
            <div class="handle" @click="clickLearnResult(scope.row.video_id)">
              学习结果
            </div>
            <div class="handle" @click="distributTeacher(scope.row)">
              分配任课老师
            </div>
            <div class="handle" @click="setCourseLearningTime(scope.row)" v-if="userType === '1' || userType === '52'">
              <span v-if="scope.row.checkTime">修改学习时间</span>
              <span v-else>设置学习时间</span>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageObj.page"
      :page-sizes="[10, 20, 30, 40]" :page-size="pageObj.pageSize" layout="total, sizes, prev, pager, next, jumper"
      background :total="total">
    </el-pagination>
    <SetCourseLearningTime ref="setcourse" :ids="classCourseIds" :params="operateParam" v-if="setCourseLearningTimeVisible"
      :classTeacher="classTeacher" :phoneNumber="phoneNumber" :company="company"
      @closeSetCourseLearningTime="closeSetCourseLearningTime" />

    <!-- 分配任课老师 -->
    <el-dialog title="分配任课老师" :visible.sync="distributShow" class="score_status_time_dialog" width="900px"
      @close="handleReturn">
      <!-- 教师列表 -->
      <TeacherList ref="teacherlist" :classTeachers="classTeacher" :phoneNumbers="phoneNumber" :companys="company">
      </TeacherList>
      <div class="t_export m">
        <el-button class="search-btn" type="primary" size="small" @click="onDistributTeacher">确 定</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import * as api from '@/api/ClassManagement/index'
import * as api2 from '@/api/courseware/checkCourseware'
import babelConfig from '../../../../babel.config'
import SetCourseLearningTime from './setCourseLearningTime.vue'
import TeacherList from '../teacherList.vue'
export default {
  components: {
    SetCourseLearningTime,
    TeacherList
  },
  data() {
    return {
      albumId: this.$route.query.id,
      tableData: [],
      teacherData: [],
      // 分页
      pageObj: {
        page: 1,
        pageSize: 20,
      },
      // 总数
      total: 0,
      selectedList: [],
      setCourseLearningTimeVisible: false,
      classCourseIds: '',
      operateParam: null,
      roleType: 0, // 60 为要隐藏的学院

      userType: '', // 用户类型

      distributShow: false, // 分配教师弹窗
      teacherClassId: '',  // 存储列表id，为分配教师做参数
      classTeacher: '', // 教师名称
      phoneNumber: '',  // 教师电话
      company: '',  // 助学单位
    }
  },
  methods: {
    getClassCourseList() {
      api
        .classCourseList({ albumId: this.albumId, ...this.pageObj })
        .then(({ data }) => {
          if (data.code === 100000) {
            this.tableData = data.data.list.map((item) => {
              let openTime = this.datetimeFormat(item.openTime)
              let endTime = this.datetimeFormat(item.endTime)
              let checkTime = this.datetimeFormat(item.checkTime)
              let status = item.status.substr(1)
              return {
                ...item,
                openTime,
                endTime,
                checkTime,
                status,
              }
            })
            this.total = data.data.total
          }
        })
    },

    // 改变页面接收数据大小
    handleSizeChange(val) {
      this.pageObj.pageSize = val
      this.getClassCourseList()
    },

    // 改变当前页面
    handleCurrentChange(val) {
      this.pageObj.page = val
      this.getClassCourseList()
    },
    checkLearingOutcome() { },
    // 处理选中事件
    handleSelectionChange(arr) {
      this.selectedList = arr
      const ids = []
      arr.forEach(v => {
        ids.push(v.id)
      })

      this.teacherClassId = ids.join(',')
    },
    sortChange({ column, prop, order }) {
      console.log(column)
      console.log(prop)
      console.log(order)
    },
    setCourseLearningTime(row) {
      console.log(row, this.selectedList)
      let ids = ''
      // 清空数据
      this.classTeacher = ''
      this.phoneNumber = ''
      this.company = ''
      const that = this
      if (row && row.id) {
        ids = row.id
        this.operateParam = Object.assign({ ...row }, { status: 'only' })
        // 回显
        this.classTeacher = row.teacherName
        this.phoneNumber = this.hideSafeInfo(row.phone)
        this.company = row.companyName
      } else {
        this.selectedList &&
          this.selectedList.forEach((item) => {
            ids += item.id + ','
          })
        this.operateParam = Object.assign({ status: 'batch' })
      }
      console.log('ids', ids)
      if (!ids) {
        this.$message.warning('请选择数据')
        return
      }
      this.classCourseIds = ids
      this.setCourseLearningTimeVisible = true
    },
    closeSetCourseLearningTime() {
      this.setCourseLearningTimeVisible = false
      this.getClassCourseList()
    },
    datetimeFormat(val) {
      if (!val) {
        return ''
      }
      const dt = new Date(val)
      const y = dt.getFullYear()
      const m = (dt.getMonth() + 1 + '').padStart(2, '0')
      const d = (dt.getDate() + '').padStart(2, '0')

      const hh = (dt.getHours() + '').padStart(2, '0')
      const mm = (dt.getMinutes() + '').padStart(2, '0')
      const ss = (dt.getSeconds() + '').padStart(2, '0')
      return `${y}-${m}-${d} ${hh}:${mm}:${ss}`
    },
    clickLearnResult(id) {
      this.$emit('goLearningOutcomeFromClass', id)
    },
    // 隐藏手机号中间位数
    hideSafeInfo(content) {
      if (!content) {
        return null
      }
      const hideStart = parseInt(content.length / 3)
      const hideEnd = parseInt(content.length * 2 / 3)
      const hideLength = hideEnd - hideStart
      let hideVal = '*'
      for (let i = 1; i < hideLength; i++) {
        hideVal += '*'
      }
      const oldVal = content.substring(hideStart, hideEnd)
      return content.replace(oldVal, hideVal)
    },
    // 分配任课老师弹窗
    distributTeacher(val) {
      // 回显
      this.classTeacher = val.teacherName
      this.phoneNumber = this.hideSafeInfo(val.phone)
      this.company = val.companyName
      
      this.distributShow = true
      // 存储教师id，为后面分配教师确定按钮作为参数
      this.teacherClassId = val.id
    },

    // 获取角色类型
    async getFindUserByUid() {
      const { code, data } = (await api2.getFindUserByUid(this.getUId)).data
      if (code === 100000) {

        let type = data.type.split(',');
        let flag = false;
        if (type.length > 0) {
          type.forEach(item => {
            if (item === '60') {
              flag = true;
            }
          })
        }
        if (flag) {
          this.roleType = 60
        }
        console.log('userType11', this.roleType)
      }
    },

    // 获取用户类型
    getUserByUid() {
      api2.getUserByUid(this.getUId).then(({ data }) => {
        if (data.code === 100000) {
          this.userType = data.data.type
        }
      })
    },
    // 分配老师确定按钮
    onDistributTeacher() {
      console.log('确定');
      const uids = this.$refs.teacherlist.uids
      if (uids == '') {
        this.$message.warning('请选择要分配的教师')
        return
      } else {
        api.updateRkTeacher({ id: this.teacherClassId, uids: uids })
          .then(({ data }) => {
            if (data.code === 100000) {
              this.distributShow = false
              this.$message({ type: 'success', message: data.msg })
              this.$refs.teacherlist.fullname = ''
              this.$refs.teacherlist.classTeacher = ''
              this.$refs.teacherlist.phoneNumber = ''
              this.$refs.teacherlist.company = ''
              this.$refs.teacherlist.uids = ''
              this.getClassCourseList()

            }else{
              this.$message({ type: 'error', message: data.msg })
            }
          })
      }
    },
    // 分配老师弹窗返回
    handleReturn() {
      this.distributShow = false
      this.$refs.teacherlist.fullname = ''
      this.$refs.teacherlist.pageObj = { page: 1, pageSize: 20 }
      this.$refs.teacherlist.getTeacherUserList()
    },
  },
  created() {
    // this.getCourseRecordList()
    this.getFindUserByUid();
    this.getUserByUid();
  },
  computed: {
    getUId() {
      return localStorage.getItem('uid')
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/classManagement.scss';

/deep/.el-tabs__item {
  font-size: 12px;
}

/deep/.el-tabs__item {
  padding: 0 10px !important;
}

.openingClass {
  color: #04f91d;
}

.t_export {
  margin: 0 auto;
  text-align: center;
}

.m {
  padding-top: 20px;
}

.search-btn {
  height: 32px;
  line-height: 7px;
}



.handle {
  color: #409eff;
  cursor: pointer;
  margin-left: 5px;
}

.set_tips {
  color: #d9001b;
}
</style>